import React from 'react'

import PreferencesModal from './PreferencesModal'
import MyQueriesModal from './MyQueriesModal'
import LoginRequiredModal from './LoginRequiredModal'
import Menu from './Menu'
import NotificationsContainer from './NotificationsContainer'

export default ({children}) => {
  return <div className="main-container">
      <Menu />
      <NotificationsContainer/>
      {children}
      <PreferencesModal/>
      <MyQueriesModal/>
      <LoginRequiredModal/>
  </div>
}



/** WEBPACK FOOTER **
 ** ./app/components/AppContainer.jsx
 **/